import { Modal, Form, Input } from "antd";
import { useEffect } from "react";
export default function UnidadMedidaForm({ open, onCancel, onSubmit, initialValues }) {

  const [form] = Form.useForm();
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        onSubmit(values);
        form.resetFields();
      });
  };

  return (
    <Modal
      open={open}
      title={
        initialValues
          ? "Editar Unidad de Medida"
          : "Nueva Unidad de Medida"
      }
      okText="Guardar"
      cancelText="Cancelar"
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          label="Unidad de Medida"
          name="unidad_medida"
          rules={[{ required: true, message: "Ingrese la unidad" }]}
        >
          <Input placeholder="Ej: Kg, Litro, Caja" />
        </Form.Item>
      </Form>
    </Modal>
  );
}